// extracted by mini-css-extract-plugin
export default {"headerWrap":"index_headerWrap_vs7bW","footerWrap":"index_footerWrap_fmSNc"};